import React from "react";
import { motion } from "framer-motion";
import { Check, X } from "lucide-react";

const withFP = [
  "Personalized guidance from Rose",
  "Dedicated advisor across the journey",
  "University matching against 20+ programs",
  "Application support & document review",
  "Visa & Campus France guidance",
  "Housing search with Visale workaround",
  "Arrival preparation checklist",
  "Part-time work resources",
  "Ongoing support until you land",
];
const alone = [
  "Endless late-night Reddit tabs",
  "Unclear admission requirements",
  "Housing uncertainty and scams",
  "Visa paperwork confusion",
  "Missed deadlines",
  "No one to text at midnight",
  "Learning CAF the hard way",
  "Guessing on French customs",
  "Isolation on arrival",
];

export default function AloneVsFrancePath() {
  return (
    <section className="bg-white py-24 md:py-32" data-testid="alone-vs-fp">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 mb-8">
          <span className="rule-gold" /><span className="eyebrow">The difference</span>
        </div>
        <h2 className="serif text-5xl md:text-6xl leading-[0.98] tracking-tight text-[#0d1b3e] max-w-4xl">
          Guided by FrancePath, <em className="italic text-[#b8892b]">or figuring it out alone</em>.
        </h2>

        <div className="mt-14 grid md:grid-cols-2 gap-6">
          {/* FrancePath column */}
          <motion.div
            initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }} transition={{ duration: 0.6 }}
            className="bg-[#0d1b3e] text-white p-8 md:p-10"
            data-testid="compare-francepath"
          >
            <div className="eyebrow !text-[#b8892b]">With FrancePath</div>
            <div className="serif text-3xl mt-2">A guided path</div>
            <ul className="mt-8 space-y-3">
              {withFP.map((w) => (
                <li key={w} className="flex items-start gap-3">
                  <span className="mt-1 w-5 h-5 bg-[#b8892b] text-white flex items-center justify-center shrink-0">
                    <Check size={12} />
                  </span>
                  <span className="text-[15px] text-white/90 leading-snug">{w}</span>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* Alone column */}
          <motion.div
            initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.08 }}
            className="bg-[#f5f1e8] border border-[#0d1b3e]/10 p-8 md:p-10"
            data-testid="compare-alone"
          >
            <div className="eyebrow">Going it alone</div>
            <div className="serif text-3xl mt-2 text-[#0d1b3e]">The maze</div>
            <ul className="mt-8 space-y-3">
              {alone.map((w) => (
                <li key={w} className="flex items-start gap-3">
                  <span className="mt-1 w-5 h-5 bg-[#0d1b3e]/10 text-[#4a5570] flex items-center justify-center shrink-0">
                    <X size={12} />
                  </span>
                  <span className="text-[15px] text-[#4a5570] leading-snug line-through decoration-[#4a5570]/30">
                    {w}
                  </span>
                </li>
              ))}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
